<template>
  <div class="ui-pop" v-show="show">
    <div class="ui-mask" @click="show = false"></div>
    <div class="ui-modal">
      <div class="qrcode-item">
        <div class="qrcode">
          <img src="../assets/demo/photo.png" alt="">
        </div>
        <span class="ui-btn">请扫码支付</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['show'],
  data(){
    return {
      
    }
  }
}
</script>
<style lang="scss" scoped>
.qrcode{
  width: 300px; height: 300px; font-size: 0; margin: 0 auto 47px;
  img{width: 100%; height: 100%;}
}
.qrcode-item{
  text-align: center; padding: 80px 150px 70px;
}
</style>